import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cc9af01c")

_pushScopeId("data-v-cc9af01c")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "h-10",
  src: "/img/icons/logoDefaultWithText.svg"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_default_icon = _resolveComponent("default-icon")

  return (_openBlock(), _createBlock("div", {
    class: 'bg-gray-200 p-3 text-center space-y-2' + ' ' + _ctx.canvasWidth + ' ' + _ctx.canvasRadius,
    style: {"background-image":"url('/img/landing/landingImage2.png')"}
  }, [
    _createVNode("textarea", {
      id: "Quote",
      type: "text",
      class: 'w-full h-48 bg-transparent border-gray-400 border-2 rounded-3xl p-4 text-center' + ' ' + _ctx.active,
      placeholder: "Text",
      style: _ctx.textAreaStyle
    }, null, 6),
    _createVNode("input", {
      id: "Name",
      type: "text",
      class: 'w-full bg-transparent border-gray-400 border-2 rounded-3xl px-4 text-center' + ' ' + _ctx.active,
      placeholder: "Author",
      style: _ctx.AuthorStyle
    }, null, 6),
    _createVNode("input", {
      id: "About",
      type: "text",
      class: 'w-full bg-transparent border-gray-400 border-2 rounded-3xl px-4 text-center' + ' ' + _ctx.active,
      placeholder: "About",
      style: _ctx.AboutStyle
    }, null, 6),
    _hoisted_1,
    _createVNode("div", {
      id: "Logo",
      class: 'flex w-full bg-opacity-30 bg-gray-200 border-gray-400 border-2 rounded-3xl px-4 text-center' + ' ' + _ctx.active
    }, [
      _hoisted_2,
      _createVNode(_component_default_icon, {
        icon: "logout_icon",
        "css-class": "text-gray-400",
        "icon-height": "h-10"
      })
    ], 2)
  ], 2))
})